import { render } from "./Pool.vue?vue&type=template&id=2622ffdf&scoped=true"
import script from "./Pool.vue?vue&type=script&lang=js"
export * from "./Pool.vue?vue&type=script&lang=js"

import "./Pool.vue?vue&type=style&index=0&id=2622ffdf&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2622ffdf"]])

export default __exports__